<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2">
                    <div class="text-center home-row" v-if="!loader">
                        <div class="d-flex">
                            <div class="col-2 col-md-1"></div>
                            <div class="col-3 col-md-3">Date</div>
                            <div class="col-4 col-md-4">Title HU</div>
                            <div class="col-2 col-md-3">Visible?</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="accordion col-12 col-md-8 offset-md-2"  v-if="!loader" id="accordionExample">
                    <div class="card w-100" v-for="(set, index) in db" v-bind:key="index">
                        <div class="card-header" id="headingOne">
                            <button style="padding: .375rem 0rem;" class="btn d-flex w-100" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                                <div class="col-2 col-md-1 small-fontsize">
                                    <router-link to="/article" tag="span" v-on:click.native="editPost(set[0])">
                                        <button class="bg-warning">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </router-link>
                                    <span>
                                        <button v-on:click="deletePost(set[0])" class="bg-danger">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </span>
                                </div>
                                <div class="col-md-3 col-3 small-fontsize">{{set[1].date}}</div>
                                <div class="col-4 col-md-4 small-fontsize">{{set[1].titleHU}}</div>
                                <div class="col-md-3 col-2 small-fontsize">{{set[1].visible}}</div>
                            </button>
                        </div>
                        <div :id="'collapse'+index" class="collapse" :aria-labelledby="'heading'+index" data-parent="#accordionExample">
                            <div class="card-body row d-flex">
                                <div class="col-12">
                                    <p><b>{{'Bevezető szöveg: '}}</b>{{set[1].introHU}}</p>
                                    <p><b>{{'Link: '}}</b>{{set[1].linkHU}}</p>
                                </div>
                                <!--<div class="col-12">
                                    <p><b>{{'Text HU: '}}</b>{{set.textHU}}</p>
                                    <p><b>{{'Text EN: '}}</b>{{set.textEN}}</p>
                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- SEARCHING -->
        <div class="container mt-5" v-if="!loader">
            <div class="row">
                <div class="col-12 col-md-3 text-md-right text-center">
                    <p class="search-text">Select product type:</p>
                </div>
                <div class="col-12 col-md-3">
                    <select id="search-type" v-model="searchType" class="form-control search-dropdown mb-md-0 mb-4 mt-md-0 mt-4" v-on:change="setSubCategory(searchType)">
                        <option value="bows">Bows</option>
                        <option value="arrows">Arrows</option>
                        <option value="quivers">Quivers</option>
                        <option value="targets">Targets</option>
                        <option value="protective-equipments">Protective Equipments</option>
                        <option value="others">Others</option>
                    </select>
                </div>
                <div class="col-12 col-md-3" v-if="isSubCategory">
                    <select v-model="finalType" class="form-control search-dropdown mb-md-0 mb-4 mt-md-0 mt-4">
                        <option :value="index" v-for="(item, index) in subCategory" v-bind:key="index">{{ index }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <p class="btn search-btn" v-on:click="search(searchType)">Show</p>
                </div>
            </div>
            <div class="text-center row" v-if="isSearch">
                <div class="row col-md-8 offset-md-2">
                    <div class="home-row">
                        <div class="d-flex">
                            <div class="col-md-1 col-4"></div>
                            <div class="col-8 col-md-3">Név</div>
                            <div class="col-md-3 d-none d-md-block">Name</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion row" id="accordionExample">
                <div class="col-md-8 offset-md-2">
                    <div class="card w-100" v-for="(item, index) in products_db" v-bind:key="index">
                        <div class="card-header" id="headingOne">
                            <button style="padding: .375rem 0rem;" class="btn d-flex w-100" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                                <div class="col-md-1 col-4 small-fontsize">
                                    <router-link to="/product" tag="span" v-on:click.native="editProduct(searchType, '', index)">
                                        <button class="bg-warning">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </router-link>
                                    <span>
                                        <button v-on:click="deleteProduct(searchType, '', index)" class="bg-danger">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </span>
                                </div>
                                <div class="col-8 col-md-3 small-fontsize">{{item.nameHU}}</div>
                                <div class="col-md-3 d-none d-md-block small-fontsize">{{item.nameEN}}</div>
                            </button>
                        </div>
                        <div :id="'collapse'+index" class="collapse" :aria-labelledby="'heading'+index" data-parent="#accordionExample">
                            <div class="card-body row d-flex">
                                <div class="col-md-6 col-12">
                                    <p><b>{{'Price HU: '}}</b>{{ item.priceHU }}</p>
                                    <p><b>{{'Material HU: '}}</b>{{ item.materialHU }}</p>
                                    <p><b>{{'Link HU: '}}</b>{{ item.linkHU }}</p>
                                    <p><b>{{'Text HU: '}}</b>{{ item.textHU }}</p>
                                </div>
                                <div class="col-md-6 col-12">
                                    <p><b>{{'Link EN: '}}</b>{{ item.linkEN }}</p>
                                    <p><b>{{'Color: '}}</b>{{ item.color }}</p>
                                    <p><b>{{'Image name: '}}</b>{{ item.img }}</p>
                                </div>
                                <div class="col-12">
                                    <hr>
                                    <div class="d-flex justify-content-around flex-wrap flex-md-nowrap">
                                        <p><b>{{'Size: '}}</b>{{ item.size }}</p>
                                        <p><b>{{'Strength: '}}</b>{{ item.strength }}</p>
                                        <p><b>{{'Manufacturer: '}}</b>{{ item.manufacturer }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loader" class="col-12 text-center loading-container">
                <div class="loading-spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Bus }  from "../bus.js";
    import firebase from 'firebase';

    export default {
        data: function () {
            return {
                db: [],
                database : firebase.database(),
                products_db : [],
                subCategory: null,
                loader: true,
                searchType: null,
                finalType: null,
                isSearch: false,
                isSubCategory: false
            };
        },
        created: function () {
            let self = this;
            let dbRef = this.database.ref("news/").orderByChild("date");
            
            dbRef.on('value', function(snapshot) {
                snapshot.forEach(function(child) {
                    self.db.push([child.key, child.val()]);
                    
                });
            });

            this.db.reverse();
            this.loader = false;
        },
        watch: {
            finalType: function (val) {
                this.finalType = val;
            }
        },
        methods: {
            search: function(type){
                let self = this;
                let dbRef;

                if(this.isSubCategory == true){
                    dbRef = this.database.ref("products/"+type+'/'+this.finalType);
                }else{
                    dbRef = this.database.ref("products/"+type);
                }

                dbRef.on('value', function(snapshot) {
                    self.products_db = snapshot.val();
                    self.isSearch = true;
                });
            },
            setSubCategory: function(type){
                let self = this;
                let dbRef = this.database.ref("products/"+type);
            
                if(type == "bows"){
                    dbRef.on('value', function(snapshot) {
                        self.subCategory = snapshot.val();
                        self.isSubCategory = true;
                    });
                }else{
                    self.isSubCategory = false;
                }
            },
            deletePost: function(id){
                if (confirm('Are you sure you want to delete this post?')) {
                    this.database.ref("news/"+id).remove();
                }
            },
            editPost: function(id){
                Bus.$emit("post", id);
            },
            deleteProduct: function(type, subCategory, id){
                if (confirm('Are you sure you want to delete this product?')) {
                    if(type == "bows"){
                        this.database.ref("products/"+type+"/"+this.finalType+'/'+id).remove();
                    }else{
                        this.database.ref("products/"+type+"/"+id).remove();
                    }
                    
                }
            },
            editProduct: function(type, subCategory, id){
                if(type == "bows"){
                    Bus.$emit("product", type, this.finalType, id);
                }else{
                    Bus.$emit("product", type, "", id);
                }
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Home.vue